import { motion } from "framer-motion";
import { Phone, Mail, MapPin, Clock, Navigation } from "lucide-react";
import { useContent } from "@/lib/content";

export default function Footer() {
  const c = useContent();
  const mapEmbed = `https://www.google.com/maps?q=${c.map_lat},${c.map_lng}&z=17&output=embed`;
  const mapDirections = `https://www.google.com/maps/dir/?api=1&destination=${c.map_lat},${c.map_lng}`;
  const phoneDigits = c.contact_phone.replace(/\D/g, "").replace(/^39/, "");
  const telHref = `tel:+39${phoneDigits}`;
  return (
    <footer
      id="contatti"
      data-testid="footer-contacts"
      className="border-t border-[rgba(176,132,51,0.25)] bg-[#080808] px-6 md:px-16 pt-24 pb-28"
    >
      <div className="max-w-[1400px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8 }}
          className="grid grid-cols-1 md:grid-cols-2 gap-14 mb-20"
        >
          <div>
            <img src="/assets/logo-full.png" alt="Full Stack 24/7 Gym" className="h-16 md:h-20 w-auto mb-8" />
            <p className="flex items-center gap-3 text-bone/70 mb-4">
              <Clock size={18} className="text-gold shrink-0" />
              Aperta 24 ore su 24, 365 giorni all'anno
            </p>
            <p className="font-editorial italic text-bone/50 text-lg">
              Forza, disciplina e risultati. Una vera community.
            </p>
          </div>

          <div className="flex flex-col gap-6 md:items-end">
            <h3 className="font-display text-2xl tracking-[0.25em] text-gold">CONTATTI</h3>
            <a
              data-testid="contact-phone"
              href={telHref}
              className="flex items-center gap-3 text-bone/80 hover:text-gold transition-colors duration-300 text-lg"
            >
              <Phone size={18} className="text-gold" /> {c.contact_phone}
            </a>
            <a
              data-testid="contact-email"
              href={`mailto:${c.contact_email}`}
              className="flex items-center gap-3 text-bone/80 hover:text-gold transition-colors duration-300 text-lg"
            >
              <Mail size={18} className="text-gold" /> {c.contact_email}
            </a>
            <p data-testid="contact-address" className="flex items-center gap-3 text-bone/80 text-lg">
              <MapPin size={18} className="text-gold shrink-0" /> {c.contact_address}
            </p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8 }}
          className="mb-20"
        >
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-6 mb-6">
            <h3 className="font-display text-2xl md:text-3xl tracking-[0.25em] text-bone">
              DOVE <span className="text-gold">TROVARCI</span>
            </h3>
            <a
              data-testid="directions-button"
              href={mapDirections}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 border border-gold/60 text-gold font-display tracking-[0.2em] text-lg px-8 py-3 hover:bg-gold hover:text-ink transition-colors duration-300 self-start"
            >
              <Navigation size={18} /> INDICAZIONI STRADALI
            </a>
          </div>
          <div className="border border-[rgba(176,132,51,0.3)] overflow-hidden">
            <iframe
              data-testid="google-map"
              title="Mappa Full Stack 24/7 Gym — Gioia Tauro"
              src={mapEmbed}
              className="w-full h-[320px] md:h-[400px] grayscale invert-[0.92] contrast-[0.9]"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
        </motion.div>

        <div className="border-t border-[rgba(176,132,51,0.15)] pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-display tracking-[0.3em] text-bone/40 text-sm">
            FULL STACK 24/7 GYM — © 2026
          </p>
          <a
            data-testid="admin-link"
            href="/admin"
            className="text-bone/30 hover:text-gold text-xs tracking-widest transition-colors duration-300"
          >
            AREA RISERVATA
          </a>
        </div>
      </div>
    </footer>
  );
}
